var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"my-10 px-5 py-4 justify-center"},[_c('p',[_vm._v(_vm._s(_vm.text[_vm.locale][_vm.type]))]),_c('canvas',{attrs:{"id":"canvas"}})])}
var staticRenderFns = []

export { render, staticRenderFns }